<template>
  <div class="container">
    <div class="col-md-10 col-sm-11 mx-auto">
      <h3>Bulk game import</h3>
      <div v-if="errorMessages.length">
        <b>Errors:</b>
        <ul>
          <li class="text-danger" v-for="(e, index) in errorMessages" v-bind:key="index">{{ e }}</li>
        </ul>
      </div>
      <form>
        <div class="form-inline">
          <div class="form-group">
            <label for="filePicker" class="col-auto">Select a file:</label>
            <input type="file" id="filePicker" @change="loadFile" class="col-auto">
          </div>
          <button
            type="submit"
            class="btn btn-success"
            @click="importGames()"
            v-if="loaded.length && !errorMessages.length && !submitted"
          >Import Games</button>
        </div>
      </form>
      <div v-if="loaded.length" class="table-responsive">
        <table class="table table-sm table-hover table-striped">
          <thead>
            <tr>
              <td>#</td>
              <td>Name</td>
              <td>Key</td>
              <td>Notes</td>
              <td>Dlc</td>
              <td>Submitted</td>
              <td>Redeemed</td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(game, index) in loaded" v-bind:key="index">
              <td>{{ index }}</td>
              <td>{{ game.name }}</td>
              <td>{{ game.key }}</td>
              <td>{{ game.notes }}</td>
              <td>
                <ul>
                  <li v-for="(dlc, index2) in game.dlcs" v-bind:key="index2">
                    {{ dlc.name }} {{ dlc.key }} {{ dlc.notes }}
                  </li>
                </ul>
              </td>
              <td>{{ game.submitTime }}</td>
              <td>{{ game.redeemTime }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
const yaml = require('js-yaml')

export default {
  name: 'BulkImport',
  props: ['user'],
  data() {
    return {
      loaded: [],
      errorMessages: [],
      submitted: false,
      keyBatches: []
    }
  },
  mounted() {
    // Redirect if user is not in admin group
    if (!this.userIsInGroup('admins')) {
      this.$router.push('/')
    }
  },
  methods: {
    userIsInGroup(group) {
      // The token payload holds an array of groups the user is in and indexOf will return the
      // index of the group name if it is found but -1 if it is not
      try {
        return this.user.signInUserSession.accessToken.payload['cognito:groups'].indexOf(group) > -1
      } catch {
        // User wasn't logged in so token didn't exist
        return false
      }
    },
    loadFile(event) {
      if (event.target.files && event.target.files[0]) {
        this.errorMessages = []
        this.loaded = []
        const reader = new FileReader()
        reader.readAsText(event.target.files[0])
        reader.onload = () => {
          try {
            this.loaded = yaml.load(reader.result)
            this.validateLoaded()
          } catch (e) {
            this.errorMessages.push(e)
          }
        }
      }
    },
    validateLoaded() {
      if (!this.loaded.length){
        this.errorMessages.push('Did not find any games in file')
        return false
      }

      this.loaded.forEach((game, index) => {
        if (!game.name || !game.name.length) {
          this.errorMessages.push("Game "+index+" doesn't have a name")
        }
        if (!game.key || !game.key.length) {
          this.errorMessages.push("Game "+index+" doesn't have a key")
        }
        if (game.dlcs) {
          game.dlcs.forEach((dlc, index2) => {
            if (!dlc.name || !dlc.name.length) {
              this.errorMessages.push("Dlc "+index2+" for game "+index+" doesn't have a name")
            }
            if (!dlc.key || !dlc.key.length) {
              this.errorMessages.push("Dlc "+index2+" for game "+index+" doesn't have a key")
            }
          })
        }
      })

      return !this.errorMessages.length
    },
    async importGames() {
      this.loading = true

      // Parse data and fix fields
      for (var k=0; k<this.loaded.length; k++) {
        // Default submitter to this user if not specified
        if (!('submitter' in this.loaded[k])) {
          this.loaded[k]['submitter'] = this.user.username
        }
        // Default redeemer to this user if the key was redeemed and no redeemer is listed
        if (!('redeemer' in this.loaded[k]) && 'redeemTime' in this.loaded[k]) {
          this.loaded[k]['redeemer'] = this.user.username
        }
        this.loaded[k]['redeemed'] = ('redeemTime' in this.loaded[k])
      }
      
      for (var batchStart=0; batchStart<this.loaded.length; batchStart+=25) {
        
        var keyBatch = this.loaded.slice(batchStart, batchStart+25) // Next 25 items

        this.keyBatches.push(keyBatch)

        //console.log(keyBatch)

        // Submit chunk import
        await this.$apollo.mutate({
            mutation: gql`mutation bulkSubmitKey ($keys: [KeyInputForBulk!]!) {
              bulkSubmitKey(keys: $keys) {
                KeyId
              }
            }`,
            variables: {
              keys: keyBatch
            }
        })
        // .then((data) => {
        //   console.log(data)
        // })
        .catch((error) => {
          this.errorMessages.push('Failed to upload batch[' + batchStart + ', ' + (batchStart+25) +']')
          this.errorMessages.push('Please remove any prior keys from the file before continuing')
          // Change form to submitted confirmation
          this.errorMessages.push(error)
          this.loading = false
          window.scrollTo(0,0)
        })

      }
      
      this.loading = false
      this.submitted = true
    }
  }
}
</script>